let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cTgaJ")).then(() => parcelRequire('9bXg4'));